module.exports = __webpack_public_path__ + "img/bus_yellow_1.f5725195.svg";